import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {UserSearchCity} from '@models/search';
import {AdService} from '@services/ad.service';
import {AlertService} from '@services/alert.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-dupplicate-city',
    templateUrl: './dupplicate-city.component.html',
    styleUrls: ['./dupplicate-city.component.scss']
})
export class DupplicateCityComponent implements OnInit {

    favoriteForm = new UntypedFormGroup({
        title: new UntypedFormControl(''),
    });
    currentSearch: UserSearchCity;
    loading = false;

    constructor(
        private adService: AdService,
        private alertService: AlertService,
        public dialogRef: MatDialogRef<DupplicateCityComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit(): void {
        this.currentSearch = this.data.userSearch;

        this.favoriteForm = new UntypedFormGroup({
            title: new UntypedFormControl(this.currentSearch.title),
        });
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onYesClick(): void {
        if (this.favoriteForm.valid && this.loading == false) {
            this.loading = true;
            const newUserSearch: UserSearchCity = {
                id: null,
                title: this.favoriteForm.get('title').value,
                search_city_params: this.currentSearch.search_city_params,
            };

            this.adService.addUserSearchCity(newUserSearch).subscribe((us) => {
                this.dialogRef.close({currentSearch: us});
            }, error => {
                this.alertService.error('une erreur est survenue, veuillez réessayer ou nous contacter si le problème persiste.');
                console.log(error);
                this.loading = false;
            });
        }
    }
}
